import React  from "react";
import { NumericFormat } from "react-number-format";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { selectOutputTypeTotalByProp } from "./outputsSlice";
import { removeZero } from "../../utils";

export const Percent = ({ type, prop, margin, value }) => {
	const total = useSelector(state => selectOutputTypeTotalByProp(state, {type, prop}));

	return (
		<Typography sx={{textAlign: "end", pr: 1.75, fontWeight: "bold"}} noWrap>
			<NumericFormat
				value={removeZero(value || ((margin - total)/margin)*100)}
				suffix=" %"
				displayType="text"
				fixedDecimalScale
				thousandSeparator=","
				decimalScale={2}
				allowNegative={false}
			/>
		</Typography>
	);
};